import React from 'react'
import Navbar from '../inc/Navbar'
import WeddingSaree from './WeddingSaree'
import {Link} from "react-router-dom";

function Weddingpage() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />
             <div className='ranaghatsaree'>
        <div className="album py-1">
          <div className="container mt-2">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Wedding Collection</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
<br/>
            <WeddingSaree/>
            <br/>
        </div>
    )
}

export default Weddingpage